import React from 'react';
import PropTypes from 'prop-types';
import { Row } from 'antd';
import { cepMask } from 'utils/masks';
import * as S from './styles';

export default function Endereco({ dados }) {
  return (
    <>
      <Row>
        <S.ContainerLabelValor>
          <S.Label>CEP</S.Label>
          <S.Valor>{cepMask(dados?.cep)}</S.Valor>
        </S.ContainerLabelValor>

        <S.ContainerLabelValor>
          <S.Label>Logradouro</S.Label>
          <S.Valor>{dados?.logradouro}</S.Valor>
        </S.ContainerLabelValor>

        <S.ContainerLabelValor>
          <S.Label>Complemento</S.Label>
          <S.Valor>{dados?.complemento}</S.Valor>
        </S.ContainerLabelValor>

        <S.ContainerLabelValor>
          <S.Label>Número</S.Label>
          <S.Valor>{dados?.numero}</S.Valor>
        </S.ContainerLabelValor>

        <S.ContainerLabelValor>
          <S.Label>Bairro</S.Label>
          <S.Valor>{dados?.bairro}</S.Valor>
        </S.ContainerLabelValor>

        <S.ContainerLabelValor>
          <S.Label>Cidade</S.Label>
          <S.Valor>{dados?.cidade}</S.Valor>
        </S.ContainerLabelValor>
      </Row>

      <Row>
        <S.ContainerLabelValor>
          <S.Label>Estado</S.Label>
          <S.Valor>{dados?.estado}</S.Valor>
        </S.ContainerLabelValor>

        <S.ContainerLabelValor>
          <S.Label>País</S.Label>
          <S.Valor>{dados?.pais}</S.Valor>
        </S.ContainerLabelValor>
      </Row>
    </>
  );
}

Endereco.propTypes = {
  dados: PropTypes.object,
};
